package com.evoapps.evoshift.data.mapper

import com.evoapps.evoshift.data.dto.auth.OwnerDto
import com.evoapps.evoshift.domain.model.Owner
import com.evoapps.evoshift.domain.model.SubscriptionStatus
import kotlin.time.Instant

class OwnerMapper {

    fun toDomain(dto: OwnerDto): Owner {
        return Owner(
            uid = dto.uid,
            businessName = dto.businessName,
            subscriptionStatus = try {
                SubscriptionStatus.valueOf(dto.subscriptionStatus)
            } catch (e: Exception) {
                SubscriptionStatus.TRIAL // Default fallback
            },
            workplaceIds = dto.workplaceIds,
            trialStartedAt = dto.trialStartedAt?.let { runCatching { Instant.parse(it) }.getOrNull() }
        )
    }

    fun toDto(domain: Owner): OwnerDto {
        return OwnerDto(
            uid = domain.uid,
            businessName = domain.businessName,
            subscriptionStatus = domain.subscriptionStatus.name,
            workplaceIds = domain.workplaceIds,
            trialStartedAt = domain.trialStartedAt?.toString()
        )
    }
}
